<template>
  <div class="table_description ">
    <div class="flex flex_between flex_1">
      <div class="tertiary_color text_left flex_3">
        {{ $t("seller.marketSounding.table.description") }}
      </div>
      <div class="tertiary_color text_right flex_1">
        <div>
			<el-dropdown @command="(command) => command()">
				<md-button class="md-blank">
					{{ $t("common.allSelected") }}<i class="el-icon-arrow-down el-icon--right"></i>
				</md-button>
				<el-dropdown-menu slot="dropdown">
					<el-dropdown-item v-for="(item, index) in actionList"
									  :key="index"
									  :command="item.command"
									  :disabled="item.disabled"
					>
						<i :class="item.icon"></i>
						{{ item.text }}
					</el-dropdown-item>
				</el-dropdown-menu>
			</el-dropdown>
		<!-- place holder for button group for selected rows-->
		<!-- place holder for button group for selected rows-->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {enumDef} from "@/common/enumDefs";
import {prospectiveReceivableApi} from "@/common/api/prospectiveReceivableApi";
import {receivableApi} from "@/common/api/receivableApi";

export default {
	props: {
		selectedRows: {
			type: Array,
			default: []
		}
	},
	methods: {
		confirmSubmitSelectedRows() {
			let ids = this.selectedRows.filter(row => this.checkSubmittable(row)).map(row => row.opportunityId);
			let option = {
				title: this.$t("seller.marketSounding.submission.multi.confirm.title"),
				msg: this.$t("seller.marketSounding.submission.multi.confirm.text", {submittableCounter: ids.length}),
				confirmFun: this.submitSelectedRows,
				params: ids
			}
			this.confirmMeg(option, true);
		},
		submitSelectedRows(ids) {
			prospectiveReceivableApi.operation.submitReviewSelected(ids)
				.then(() => {
						this.toastSuccess();
						this.$emit("table-head-action-executed");
				}).catch(this.toast);
		},
		confirmConvertSelectedRows() {
			let ids = this.selectedRows.filter(row => this.checkConvertable(row)).map(row => row.receivableId);
			let option = {
				title: this.$t("seller.marketSounding.convert.multi.confirm.title"),
				msg: this.$t("seller.marketSounding.convert.multi.confirm.text", {convertableCounter: ids.length}),
				confirmFun: this.convertSelectedRows,
				params: ids
			}
			this.confirmMeg(option, true);
		},
		convertSelectedRows(ids) {
			prospectiveReceivableApi.operation.convertSelected(ids)
				.then(() => {
					this.toastSuccess();
					this.$emit("table-head-action-executed");
				}).catch(this.toast);
		},
		confirmWithdrawSelectedRows() {
			let ids = this.selectedRows.filter(row => this.checkWithdrawable(row)).map(row => row.receivableId);
			let option = {
				title: this.$t("seller.marketSounding.withdraw.multi.confirm.title"),
				msg: this.$t("seller.marketSounding.withdraw.multi.confirm.text", {withdrawableCounter: ids.length}),
				confirmFun: this.withdrawSelectedRows,
				params: ids
			}
			this.confirmMeg(option, true);
		},
		withdrawSelectedRows(ids) {
			prospectiveReceivableApi.operation.withdrawSelected(ids)
				.then(() => {
					this.toastSuccess();
					this.$emit("table-head-action-executed");
				}).catch(this.toast);
		},
		confirmDeleteSelectedRows() {
			let ids = this.selectedRows.filter(row => this.checkDeletable(row)).map(row => row.receivableId);
			let option = {
				title: "",
				msg: this.$t("seller.marketSounding.delete.multi.confirm.text", {deletableCounter: ids.length}),
				confirmFun: this.deleteSelectedRows,
				params: ids
			}
			this.confirmMeg(option, true);
		},
		deleteSelectedRows(ids) {
			receivableApi.deleteOperation(ids)
				.then(() => {
					this.toastSuccess();
					this.$emit("table-head-action-executed");
				})
				.catch(this.toast);
		},
		checkSubmittable(data) {
			return !!data.invoiceNumber && enumDef.upcomingOpportunityStatus.isDraft(data.opportunityStatus);
		},
		checkWithdrawable(data) {
			let isProspective = enumDef.receivableStatus.isProspective(data.receivableStatus);
			let isExpiredBecauseOfDueDate = data.receivableStatus === enumDef.receivableStatus.UnsoldFinished;
			let isOpportunityDraft = enumDef.upcomingOpportunityStatus.isDraft(data.opportunityStatus);
			let wasAlreadyConverted = data.opportunityConverted;

			return (isProspective || isExpiredBecauseOfDueDate) && !isOpportunityDraft && !wasAlreadyConverted;
		},
		checkConvertable(data) {
			return data.receivableStatus === enumDef.receivableStatus.ProspectiveConfirmed
		},
		checkDeletable(data) {
			return data.opportunityStatus === enumDef.upcomingOpportunityStatus.New;
		}
	},
	computed: {
		actionList() {
			return [
				{
					command: this.confirmSubmitSelectedRows,
					disabled: !this.submittable,
					icon: "fa fa-paper-plane",
					text: this.$t("common.button.toReview"),
				},
				{
					command: this.confirmConvertSelectedRows,
					disabled: !this.convertible,
					icon: "fa fa-link",
					text: this.$t("seller.marketSounding.button.convert"),
				},
				{
					command: this.confirmWithdrawSelectedRows,
					disabled: !this.withdrawable,
					icon: "fa fa-undo",
					text: this.$t("seller.marketSounding.button.withdraw"),
				},
				{
					command: this.confirmDeleteSelectedRows,
					disabled: !this.deletable,
					icon: "fa fa-trash-o",
					text: this.$t("common.delete"),
				},
			];
		},
		submittable() {
			return this.selectedRows.some(row => this.checkSubmittable(row));
		},
		withdrawable() {
			return this.selectedRows.some(row => this.checkWithdrawable(row));
		},
		convertible() {
			return this.selectedRows.some(row => this.checkConvertable(row));
		},
		deletable() {
			return this.selectedRows.some(row => this.checkDeletable(row));
		},
	}

};
</script>